// apps/nos/client/src/lib/amplitudeInit.ts
// Imported first thing in main.tsx — runs amplitude.initAll() once at module load.

import * as amplitude from "@amplitude/unified";

const apiKey = import.meta.env.VITE_AMPLITUDE_API_KEY as string | undefined;
const mode = import.meta.env.MODE;
const isProd = mode === "production";
const isDevEc2 = mode === "development.ec2";
const enableDev = import.meta.env.VITE_AMPLITUDE_ENABLE_DEV === "1";
const enabled = !!apiKey && (isProd || isDevEc2 || enableDev);

const environment = isProd ? "production" : isDevEc2 ? "dev-ec2" : "development";

if (enabled) {
  void amplitude.initAll(apiKey!, {
    analytics: { autocapture: true },
    sessionReplay: { sampleRate: 1 },
  });
  // Environment is injected as an EVENT property on every event by
  // eventLogger.logEvent — that's the reliable filter key in Amplitude.
  // We deliberately do NOT set it as a user property here: at init time
  // there's no signed-in user yet, so user-property writes land on the
  // anonymous device record and may not transfer cleanly to the named
  // user after setUserId().
  console.log(`[amplitude] initialized environment=${environment}`);
} else {
  console.log(
    `[amplitude] disabled (apiKey=${apiKey ? "set" : "unset"}, MODE=${mode}, VITE_AMPLITUDE_ENABLE_DEV=${import.meta.env.VITE_AMPLITUDE_ENABLE_DEV ?? "<unset>"})`,
  );
}

export const amplitudeEnabled = enabled;
export const amplitudeEnvironment = environment;
export { amplitude };
